import "./App.css";
import _ from "lodash";
import Layout from "./components/layout";

function App() {
  return (
    <div className="App" style={{ width: "100vw", height: "100vh" }}>
      <Layout />
    </div>
  );
}

export default App;
